import type { ReactNode } from "react";
import { ContentWithSidebarTemplate } from "./ContentWithSidebarTemplate";

interface ArticleTemplateProps {
  header: ReactNode;
  media?: ReactNode;
  body: ReactNode;
  afterBody?: ReactNode;
  sidebar: ReactNode;
}

export function ArticleTemplate({ header, media, body, afterBody, sidebar }: ArticleTemplateProps) {
  return (
    <ContentWithSidebarTemplate
      content={
        <article className="mx-auto w-full max-w-[860px] overflow-hidden rounded-2xl">
          {header}
          {media}
          {body}
          {afterBody}
        </article>
      }
      sidebar={sidebar}
    />
  );
}
